import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.admin.as.view');
import { OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-afterservice-admin-as-view',
template: templateSource || '',
    styles: [``],
})
export class PortalAfterserviceAdminAsViewComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;
    @Input() postId!: string;

    public data: any = {};
    public statusView: '접수대기' | '진행' | '완료' | '' = '';

    constructor(@Inject( Router)         private router: Router,@Inject( Service    )         public service: Service    ) {}

    async ngOnInit() {
        await this.service.init();
        if (!this.postId) return;
        await this.load();
        await this.service.render();
    }

    private async showModal(message: string): Promise<void> {
        await this.modalMessage.open({ message });
    }

    async load(): Promise<void> {

        const res = await wiz.call('view', { id: this.postId });

        if (!res || res.code !== 200) return;

        this.data = res.data?.post || {};

        this.data.installed = this.formatDate(this.data.installed);
        this.data.processing_date = this.formatDate(this.data.processing_date);

        this.statusView = this.data.status || '';

        if (this.statusView === '완료') {
            this.data.travel_fee = this.formatNumber(this.data.travel_fee);
            this.data.part_fee = this.formatNumber(this.data.part_fee);
            this.data.total_fee = this.formatNumber(this.data.total_fee);
        }
    }

    async registerReady() {

        const payload = {
            ...this.data,
            processing_date: this.formatDate(this.data.processing_date)
        };

        const res = await wiz.call('update', payload);

        if (res?.code === 200) {
            await this.showModal('담당자 배정이 완료되었습니다.');
            this.router.navigate(['/admin/as/list']);
        } else {
            await this.showModal('접수에 실패했습니다.');
        }
    }

    async registerCompletion() {

        const payload = {
            ...this.data,
            travel_fee: this.parseNumber(this.data.travel_fee),
            part_fee: this.parseNumber(this.data.part_fee),
            total_fee: this.parseNumber(this.data.total_fee)
        };

        const res = await wiz.call('update2', payload);

        if (res?.code === 200) {
            await this.showModal('A/S 보고서가 등록되었습니다.');
            this.router.navigate(['/admin/as/list']);
        } else {
            await this.showModal('보고서 등록 실패');
        }
    }

    async mobileFormat() {

        if (!this.data.engineer_mobile) return;

        this.data.engineer_mobile = this.data.engineer_mobile
            .replace(/[^0-9]/g, '')
            .replace(
                /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                '$1-$2-$3'
            )
            .replace('--', '-');
        await this.service.render();
    }

    async calculateTotal() {

        const travel = this.parseNumber(this.data.travel_fee);
        const part = this.parseNumber(this.data.part_fee);
        const total = travel + part;

        this.data.travel_fee = this.formatNumber(travel);
        this.data.part_fee = this.formatNumber(part);
        this.data.total_fee = this.formatNumber(total);
        await this.service.render();
    }

    formatNumber(value) {
        const num = Number(value);
        if (isNaN(num)) return '0';
        return num.toLocaleString();
    }

    parseNumber(value) {
        if (!value) return 0;
        return Number(value.toString().replace(/,/g, '')) || 0;
    }

    formatDate(date) {
        if (!date) return '';
        return moment(date).format('YYYY-MM-DD');
    }
}

export default PortalAfterserviceAdminAsViewComponent;